import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f29c480"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-container" }
const _hoisted_2 = { class: "user-info" }
const _hoisted_3 = { class: "name-label" }
const _hoisted_4 = { class: "name-label" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "로그인 >", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/icon/settings.png",
    srcset: "/assets/icon/settings@2x.png 2x,/assets/icon/settings@3x.png 3x"
  })
], -1))
const _hoisted_8 = { class: "main-container" }
const _hoisted_9 = { class: "main_padding" }
const _hoisted_10 = { class: "main-title" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, " 스톡옵션 ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "상세보기", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "right_btn",
  src: "/assets/icon/btn_right.png",
  srcset: "/assets/icon/btn_right@2x.png 2x,/assets/icon/btn_right@3x.png 3x"
}, null, -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "wbox-radius" }
const _hoisted_16 = { class: "wbox-content" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "comb-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "comb-status" }, "보유현황")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "스톡옵션 세금계산기 > ", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createTextVNode("발급 받은 코드를 입력하세요")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 해외 사용자용 코드가 필요한가요? ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 1:1 문의 ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 해주세요 ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 닫기 ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 로그인 하기 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ag_header = _resolveComponent("ag-header")!
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ag_button = _resolveComponent("ag-button")!
  const _component_ag_footer = _resolveComponent("ag-footer")!
  const _component_ag_content = _resolveComponent("ag-content")!
  const _component_ag_modal = _resolveComponent("ag-modal")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", {
                    class: "user-name",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openTesterLoginModal()))
                  }, _hoisted_6)
                ]),
                _createVNode(_component_router_link, {
                  class: "ion-activatable ripple-parent",
                  to: "/settings",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'설정버튼영역', 'clickContent':'설정버튼클릭'});})
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", {
                  class: "right",
                  onClick: _cache[2] || (_cache[2] = () => {
                _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'스톡옵션', 'clickContent':'상세보기'})
                _ctx.router.push({name:'StockOption'})
              })
                }, _hoisted_14)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", {
                    class: "stock-info",
                    onClick: _cache[3] || (_cache[3] = () => {
                  _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'스톡옵션', 'clickContent':'스톡옵션세금계산기'})
                  _ctx.router.push({name:'StockOption', params : {scroll: 'calc'}})
                })
                  }, _hoisted_19)
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ag_modal, {
        "model-value": _ctx.isOpenCodeLogin,
        "backdrop-dismiss": "",
        "swipe-to-close": "",
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.setOpenCodeLogin(false)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_header, { handle: "" }),
          _createVNode(_component_ag_content, null, {
            default: _withCtx(() => [
              _createVNode(_component_ag_box, { p: "10px" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ag_text, null, {
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_box, {
                    bg: "gray5",
                    mt: "7px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        inputmode: "text",
                        mode: "md",
                        placeholder: "발급 받은 코드 예) GLLE4U67e",
                        onIonInput: _ctx.setExceptionToken
                      }, null, 8, ["onIonInput"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_text, {
                    color: "gray2",
                    typography: "main12r"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_text, {
                    color: "gray1",
                    typography: "main12r",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeCodeLoginAndOpenChannelTalk()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_22
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_text, {
                    color: "gray2",
                    typography: "main12r"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_23
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ag_footer, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ag_box, {
                    width: "100%",
                    dp: "flex"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ag_button, {
                        corner: "0",
                        grow: "1",
                        bg: "gray3",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setOpenCodeLogin(false)))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_24
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ag_button, {
                        corner: "0",
                        grow: "1",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getUuidByExceptionToken()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_25
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model-value"])
    ]),
    _: 1
  }))
}